import React from "react";

const Ads = ({
  active,
  width = 20,
  height = 20,
}: {
  active: boolean;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.75 3.24956V4.74956H4V15.2496H16V8.49956H17.5V15.9996C17.5 16.1985 17.421 16.3892 17.2803 16.5299C17.1397 16.6705 16.9489 16.7496 16.75 16.7496H3.25C3.05109 16.7496 2.86032 16.6705 2.71967 16.5299C2.57902 16.3892 2.5 16.1985 2.5 15.9996V3.99956C2.5 3.80065 2.57902 3.60988 2.71967 3.46923C2.86032 3.32858 3.05109 3.24956 3.25 3.24956H7.75ZM15.2125 4.74956L13 2.53706L14.0605 1.47656L18.0655 5.48156C18.1284 5.54449 18.1711 5.62464 18.1885 5.71188C18.2058 5.79912 18.1969 5.88954 18.1629 5.97172C18.1288 6.05389 18.0712 6.12415 17.9973 6.1736C17.9234 6.22305 17.8364 6.24948 17.7475 6.24956H11.5C11.1022 6.24956 10.7206 6.4076 10.4393 6.6889C10.158 6.97021 10 7.35174 10 7.74956V12.2496H8.5V7.74956C8.5 6.95391 8.81607 6.19085 9.37868 5.62824C9.94129 5.06563 10.7044 4.74956 11.5 4.74956H15.2125Z"
        fill={` ${active ? "#2D96A7" : "#868C98"} `}
      />
    </svg>
  );
};

export default Ads;
